export default class ApiModel<T> {
    /**
     * Safely get the current constructor.
     * This approach takes into account that class names can be mangled during minification.
     */
    private Constructor: new (data: T) => this = Object.getPrototypeOf(this).constructor

    /**
     * The literal class name of this model as a string.
     */
    Class: string = this.Constructor.name

    /*
     * The constructor assumes a single read dto, which serves as the foundation for the model's data.
     * ApiModel subclasses should NOT override the constructor for any reason.
     * The constructor's data member can be used entirely or partially as write DTO when necessary to update the object holding it.
     */
    constructor(public data: T) {
        this.data = data ?? ({} as T)
    }

    /**
     * Deeply clone this model with the given field overrides.
     * The resulting model has the same identity and must either replace the original or be destroyed.
     */
    clone(override: Partial<T> = {}) {
        const copy: T = { ...this.data, ...override }
        return new this.Constructor(copy)
    }

    /**
     * Create an instance of this model if the given argument is not falsy.
     * Otherwise, return undefined.
     */
    static nullable<T, R extends new (data: T) => InstanceType<R>>(
        this: R, // NOTE: static `this` is not included in argument list.
        data?: T | undefined | null
    ): InstanceType<R> | undefined {
        return data ? new this(data) : undefined
    }
}
